import { Link } from 'react-router-dom';
import { useLanguage } from '../../shared/hooks/useLanguage';
import { TWITTER_URL, BLUESKY_URL, GITHUB_URL, BUY_ME_A_COFFEE_URL } from '../../shared/config/constants';
import './SiteFooter.css';

interface SiteFooterProps {
  blogName?: string;
  twitterUrl?: string;
  blueskyUrl?: string;
  githubUrl?: string;
}

/**
 * サイトフッターコンポーネント
 * SiteHeaderと統一感のあるログ風デザイン
 */
const SiteFooter: React.FC<SiteFooterProps> = ({
  blogName = 'Version0.1',
  twitterUrl = TWITTER_URL,
  blueskyUrl = BLUESKY_URL,
  githubUrl = GITHUB_URL,
}) => {
  const lang = useLanguage();
  const currentYear = new Date().getFullYear();

  // 多言語対応のテキスト
  const buyMeACoffeeText = lang === 'ja' 
    ? 'このログが少しでも面白かったら、コーヒー1杯分の応援ができます。'
    : 'If you enjoyed this log, you can support it with a coffee.';
  const privacyPolicyText = lang === 'ja' ? 'プライバシーポリシー' : 'Privacy Policy';
  const termsOfServiceText = lang === 'ja' ? '利用規約' : 'Terms of Service';
  const twitterText = lang === 'ja' ? 'X' : 'X';
  const blueskyText = lang === 'ja' ? 'BlueSky' : 'BlueSky';
  const githubText = lang === 'ja' ? 'GitHub' : 'GitHub';
  const copyrightText = lang === 'ja' 
    ? `© ${currentYear} ${blogName}`
    : `© ${currentYear} ${blogName}`;

  return (
    <footer className="site-footer">
      <div className="site-footer__container">
        {/* EOF区切り線 */}
        <div className="site-footer__eof">
          <span className="site-footer__eof-line">--- EOF ---</span>
        </div>

        <div className="site-footer__logs">
          {/* コピーライト */}
          <div className="site-footer__log site-footer__log--info">
            <span className="site-footer__log-level">[info]</span>
            <span className="site-footer__log-message">
              {copyrightText}
            </span>
          </div>

          {/* プライバシーポリシー、利用規約 */}
          <div className="site-footer__log site-footer__log--info">
            <span className="site-footer__log-level">[info]</span>
            <span className="site-footer__log-message">
              <Link 
                to={`/${lang}/privacy-policy`}
                className="site-footer__log-link"
              >
                {privacyPolicyText}
              </Link>
              {' | '}
              <Link 
                to={`/${lang}/terms-of-service`}
                className="site-footer__log-link"
              >
                {termsOfServiceText}
              </Link>
            </span>
          </div>

          {/* SNSリンク */}
          <div className="site-footer__log site-footer__log--sns">
            <span className="site-footer__log-level">[sns]</span>
            <span className="site-footer__log-message">
              {twitterUrl && (
                <>
                  <a
                    href={twitterUrl}
                    className="site-footer__log-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {twitterText}
                  </a>
                </>
              )}
              {blueskyUrl && (
                <>
                  {twitterUrl && ' | '}
                  <a
                    href={blueskyUrl}
                    className="site-footer__log-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {blueskyText}
                  </a>
                </>
              )}
              {githubUrl && (
                <>
                  {(twitterUrl || blueskyUrl) && ' | '}
                  <a
                    href={githubUrl}
                    className="site-footer__log-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {githubText}
                  </a>
                </>
              )}
            </span>
          </div>

          {/* Buy Me a Coffee */}
          <div className="site-footer__log site-footer__log--tip">
            <span className="site-footer__log-level">[tip]</span>
            <span className="site-footer__log-message">
              <a
                href={BUY_ME_A_COFFEE_URL}
                className="site-footer__log-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {buyMeACoffeeText}
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
